import {
	message, Modal,
} from 'antd';
import React, { useCallback, useEffect } from 'react';
import {
	Switch, Route, useRouteMatch, Redirect, useHistory,
} from 'react-router-dom';
import { AppHeader } from '../../components/app-header';
import { useAppStore, useQuizStore, useSessionStore } from '../../store';
import { QuizAttemptScreen } from './quiz-attempt';
import { QuizDashboardScreen } from './quiz-dashboard';
import { QuizDetailsScreen } from './quiz-details';
import { FormType, QuizLoginScreen } from './quiz-login';
import { APP_CONFIG, NetworkStatus, isElectronApp } from '../../config';
import { QuizInvitePage } from './quiz-invite-page';

const sessionStoreSelector = (state: SessionState) => ({
	isAuthenticated: state.isAuthenticated,
	sessionData: state.sessionData,
});

const quizStoreSelector = (state: QuizState) => ({
	hasStarted: state.hasStarted,
	quizData: state.quizData,
	timeLeft: state.timeLeft,
	tabSwitchCount: state.tabSwitchCount,
	tabSwitchInCount: state.tabSwitchInCount,
	fullScreenInCount: state.fullScreenInCount,
	fullScreenOutCount: state.fullScreenOutCount,
	nextLink: state.nextLink,
	previousLink: state.previousLink,
	submittedQuestions: state.submittedQuestions,
	setQuizTimeLeft: state.setQuizTimeLeft,
	getRemainingTime: state.getRemainingTime,
	submitQuiz: state.submitQuiz,
	stopRecording: state.stopRecording,
	identityCheckCode: state.identityCheckCode,
});

const appStoreSelector = (state: AppState) => ({
	networkStatus: state.networkStatus,
	isOnline: state.isOnLine,
	multipleConnectionWarning: state.multipleConnectionWarning,
	isSocketConnected: state.isSocketConnected,
	networkStats: state.networkSpeed,
	setAppLoading: state.setAppLoading,
	setNetworkStatus: state.setNetworkStatus,
});

export const QuizScreen: React.FunctionComponent = () => {
	const match = useRouteMatch();
	const history = useHistory();

	const { isAuthenticated, sessionData } = useSessionStore(sessionStoreSelector);
	const {
		isOnline, isSocketConnected, networkStats,
		networkStatus, setNetworkStatus, setAppLoading,
		multipleConnectionWarning,
	} = useAppStore(appStoreSelector);
	const {
		nextLink, previousLink,
		hasStarted, quizData, submittedQuestions,
		tabSwitchCount,
		tabSwitchInCount,
		fullScreenInCount,
		fullScreenOutCount,
		timeLeft,
		setQuizTimeLeft, getRemainingTime,
		submitQuiz, stopRecording, identityCheckCode,
	} = useQuizStore(quizStoreSelector);

	const handleStopRecording = useCallback(async () => {
		if (!quizData?.quizId) {
			return;
		}
		try {
			stopRecording({ forceUpload: false }, quizData?.quizId);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
	}, [stopRecording, quizData?.quizId]);

	useEffect(() => {
		if (isSocketConnected) {
			return setNetworkStatus(NetworkStatus.Online);
		}
		if (isOnline) {
			return setNetworkStatus(NetworkStatus.Pending);
		}
		return setNetworkStatus(NetworkStatus.Offline);
	}, [isOnline, isSocketConnected, setNetworkStatus]);

	useEffect(() => {
		if (window.performance
			&& window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
			console.log('baccckckkkk btn 1');
			history.push({
				state: { referrer: undefined },
			});
			// window.location.reload();
		}
	}, [history]);

	const emailVerificationPage = useCallback((params) => {
		console.log(match.params);
		message.config({
			top: 0,
		});
		if (!sessionData) {
			return (
				<>
					<QuizLoginScreen
						quizName=""
						formType={FormType.EmailVerification}
						token={params.match.params.token}

					/>
				</>
			);
		}
		return <Redirect to={`/test/${params.match.params.quizName}`} />;
	}, [match, sessionData]);

	const invitePage = useCallback((params) => {
		message.config({
			top: 55,
		});

		return (
			// eslint-disable-next-line no-nested-ternary
			quizData && quizData?.isAppOnly
				? isElectronApp
					? (
						<Redirect
							exact
							to={{
								pathname: params.location.state?.referrer ?? `${match.url}/${params.match.params.quizName}/login`,
							}}
						/>
					)
					: (
						<QuizInvitePage
							token={params.match.params.token}
							quizName={params.match.params.quizName}
						/>
					)
				: <></>
		);
	}, [match.url, quizData]);

	const quizLoginScreen = useCallback((params) => {
		message.config({
			// Set the message alert just below app header
			top: 55,
		});

		return (
			<>
				{
					!isAuthenticated
						? (
							<QuizLoginScreen
								quizName={params.match.params.quizName}
							/>
						) : (
							<Redirect
								exact
								to={{
									pathname: params.location.state?.referrer ?? `${match.url}/${params.match.params.quizName}/details`,
									// state: {
									// 	referrer: params.location.state?.referrer ?? params.location.pathname,
									// },
								}}
							/>
						)
				}
			</>
		);
	}, [isAuthenticated, match]);

	const quizDetailsScreen = useCallback((params) => {
		message.config({
			// Below both header rows: title bar (36px) + toolbar (55px) + borders
			top: 93,
		});

		return (
			<>
				{
					isAuthenticated
						? (
							<>
								{
									hasStarted
										? (
											<Redirect
												exact
												to={{
													pathname: params.location.state?.referrer ?? `${match.url}/${params.match.params.quizName}/dashboard`,
													// state: {
													// 	referrer: params.location.state?.referrer
													// 	?? params.location.pathname,
													// },
												}}
											/>
										) : (
											<>
												<AppHeader
													setLoading={setAppLoading}
													networkStats={networkStats}
													quizName={params.match.params.quizName}
													quizData={quizData}
													sessionData={sessionData}
													networkStatus={networkStatus}
													stopRecording={handleStopRecording}
													identityCheckCode={identityCheckCode}
												/>
												<QuizDetailsScreen
													quizName={params.match.params.quizName}
												/>
											</>
										)
								}
							</>
						) : (
							<Redirect
								exact
								to={{
									pathname: `${match.url}/${params.match.params.quizName}/login`,
									state: {
										referrer: params.location.pathname,
									},
								}}
							/>
						)
				}
			</>
		);
	}, [
		isAuthenticated, hasStarted, match.url,
		setAppLoading, networkStats, quizData, sessionData,
		networkStatus, handleStopRecording, identityCheckCode,
	]);

	const quizDashboardScreen = useCallback((params) => {
		message.config({
			// Below both header rows: title bar (36px) + toolbar (55px) + borders
			top: 93,
		});

		return (
			<>
				{
					isAuthenticated
						? (
							<>
								{
									hasStarted
										? (
											<>
												<AppHeader
													networkStats={networkStats}
													quizName={params.match.params.quizName}
													quizData={quizData}
													setLoading={setAppLoading}
													sessionData={sessionData}
													hasQuizStarted={hasStarted}
													timeLeft={timeLeft}
													tabSwitchCount={tabSwitchCount}
													tabSwitchInCount={tabSwitchInCount}
													fullScreenInCount={fullScreenInCount}
													fullScreenOutCount={fullScreenOutCount}
													totalSubmittedQuestions={submittedQuestions.length}
													nextLink={nextLink}
													previousLink={previousLink}
													setTimeLeft={setQuizTimeLeft}
													getRemainingTime={getRemainingTime}
													submitQuiz={submitQuiz}
													networkStatus={networkStatus}
													stopRecording={handleStopRecording}
													identityCheckCode={identityCheckCode}
												/>
												<QuizDashboardScreen
													quizName={params.match.params.quizName}
												/>
											</>
										) : (
											<Redirect
												exact
												to={{
													pathname: `${match.url}/${params.match.params.quizName}/details`,
													state: {
														referrer: params.location.pathname,
													},
												}}
											/>
										)
								}
							</>
						) : (
							<Redirect
								exact
								to={{
									pathname: `${match.url}/${params.match.params.quizName}/login`,
									state: {
										referrer: params.location.pathname,
									},
								}}
							/>
						)
				}
			</>
		);
	}, [
		nextLink, previousLink, isAuthenticated,
		quizData, sessionData, submittedQuestions, hasStarted,
		match, timeLeft, setQuizTimeLeft, getRemainingTime, submitQuiz,
		tabSwitchCount,
		tabSwitchInCount,
		fullScreenInCount,
		fullScreenOutCount,
		networkStatus, networkStats,
		handleStopRecording, setAppLoading,
		identityCheckCode,
	]);

	const quizAttemptScreen = useCallback((params) => {
		message.config({
			// Below both header rows: title bar (36px) + toolbar (55px) + borders
			top: 93,
		});

		return (
			<>
				{
					isAuthenticated
						? (
							<>
								{
									hasStarted
										? (
											<>
												<AppHeader
													networkStats={networkStats}
													quizName={params.match.params.quizName}
													quizData={quizData}
													setLoading={setAppLoading}
													sessionData={sessionData}
													hasQuizStarted={hasStarted}
													timeLeft={timeLeft}
													tabSwitchCount={tabSwitchCount}
													tabSwitchInCount={tabSwitchInCount}
													fullScreenInCount={fullScreenInCount}
													fullScreenOutCount={fullScreenOutCount}
													nextLink={nextLink}
													previousLink={previousLink}
													totalSubmittedQuestions={submittedQuestions.length}
													setTimeLeft={setQuizTimeLeft}
													getRemainingTime={getRemainingTime}
													submitQuiz={submitQuiz}
													showHome
													networkStatus={networkStatus}
													stopRecording={handleStopRecording}
													identityCheckCode={identityCheckCode}
												/>
												<QuizAttemptScreen
													quizName={params.match.params.quizName}
													questionId={params.match.params.questionId}
												/>
											</>
										) : (
											<Redirect
												exact
												to={{
													pathname: `${match.url}/${params.match.params.quizName}/details`,
													state: {
														referrer: params.location.pathname,
													},
												}}
											/>
										)
								}
							</>
						) : (
							<Redirect
								exact
								to={{
									pathname: `${match.url}/${params.match.params.quizName}/login`,
									state: {
										referrer: params.location.pathname,
									},
								}}
							/>
						)
				}
			</>
		);
	}, [
		nextLink, previousLink, isAuthenticated,
		quizData, sessionData, submittedQuestions, hasStarted,
		match, timeLeft, setQuizTimeLeft, getRemainingTime, submitQuiz,
		tabSwitchCount,
		tabSwitchInCount,
		fullScreenInCount,
		fullScreenOutCount,
		networkStatus, networkStats,
		handleStopRecording,
		setAppLoading, identityCheckCode,
	]);

	const redirectionToPreview = useCallback((params) => (
		<>
			{
				window.location.replace(`${APP_CONFIG.QuizServerURL}/test/${params.match.params.quizName}/${params.match.params.code}`)
			}
		</>
	), []);

	return (
		<>
			<Modal
				title="Multiple Connections Detected"
				open={!!multipleConnectionWarning}
				footer={false}
				closable={false}
				zIndex={10001}
			>
				<p>{multipleConnectionWarning}</p>
			</Modal>
			<Switch>

				<Redirect exact from={`${match.url}/:quizName`} to={`${match.url}/:quizName/login`} />

				<Route
					exact
					path={`${match.url}/:quizName/invite/:token`}
					render={invitePage}
				/>

				<Route
					exact
					path={`${match.url}/:quizName/emailVerify/:token`}
					render={emailVerificationPage}
				/>

				<Route
					exact
					path={`${match.url}/:quizName/login`}
					render={quizLoginScreen}
				/>

				<Route
					exact
					path={`${match.url}/:quizName/details`}
					render={quizDetailsScreen}
				/>

				<Route
					path={`${match.url}/:quizName/dashboard`}
					render={quizDashboardScreen}
				/>

				<Route
					exact
					path={`${match.url}/:quizName/attempt/:questionId`}
					render={quizAttemptScreen}
				/>

				<Redirect to="/" />
			</Switch>
		</>
	);
};
